// 全局KaTeX单例管理器 - 确保预加载真正生效

class GlobalKaTeX {
  private static katex: any = null;
  private static loaded = false;
  private static loading = false;
  private static loadPromise: Promise<void> | null = null;

  /**
   * 确保KaTeX已加载，返回KaTeX实例
   */
  static async ensureLoaded(): Promise<any> {
    if (this.loaded) {
      return this.katex;
    }
    
    if (this.loading) {
      await this.loadPromise;
      return this.katex;
    }

    this.loading = true;
    this.loadPromise = this.doLoad();
    await this.loadPromise;
    return this.katex;
  }

  /**
   * 执行实际的KaTeX加载
   */
  private static async doLoad(): Promise<void> {
    try {
      // 加载KaTeX模块
      const katexModule = await import('katex');
      
      // 加载KaTeX CSS
      await import('katex/dist/katex.min.css');
      
      // 设置全局实例
      this.katex = katexModule.default;
      this.loaded = true;
      this.loading = false;
      
      console.log('✅ Global KaTeX loaded successfully');
    } catch (error) {
      this.loading = false;
      console.error('❌ Failed to load global KaTeX:', error);
      throw error;
    }
  }

  /**
   * 检查KaTeX是否已加载
   */
  static isLoaded(): boolean {
    return this.loaded;
  }

  /**
   * 获取KaTeX实例 (同步方法，仅在确认已加载时使用)
   */
  static getKaTeX(): any {
    if (!this.loaded) {
      throw new Error('KaTeX not loaded yet. Call ensureLoaded() first.');
    }
    return this.katex;
  }

  /**
   * 预加载KaTeX (异步，不等待完成)
   */
  static preload(): void {
    if (!this.loaded && !this.loading) {
      this.ensureLoaded().catch(error => {
        console.warn('KaTeX preload failed:', error);
      });
    }
  }

  /**
   * 获取加载状态信息
   */
  static getStatus(): { loaded: boolean; loading: boolean } {
    return {
      loaded: this.loaded,
      loading: this.loading
    };
  }
}

export default GlobalKaTeX;